import React from "react";
import { useTranslation } from "react-i18next";

export const About = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[70vh] flex flex-col justify-center py-12 text-slate-800">
      <section className="max-w-2xl space-y-6">
        <p className="text-sm uppercase tracking-[0.2em] text-slate-400">
          {t("about.badge", "About this project")}
        </p>
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight leading-tight text-slate-900">
          {t("about.title", "Latwe wesele is 100% free and made to make your life easier")}
        </h2>
        <p className="text-base md:text-lg text-slate-600">
          {t(
            "about.mission",
            "This page was created for couples preparing for their wedding. The goal is simple: make planning clearer, calmer and more transparent, without any fees, logins or hidden agendas. Everything here is free to use."
          )}
        </p>
        <p className="text-base md:text-lg text-slate-600">
          {t(
            "about.ideaInvitation",
            "If you have an idea for a new tool, improvement or something that would make your preparations easier, just reach out. This space is open to ideas from real couples."
          )}
        </p>
        <div className="rounded-2xl border border-slate-200 bg-white/80 p-5 shadow-sm space-y-3">
          <h3 className="text-lg font-semibold text-slate-900">
            {t("about.contactTitle", "Contact & ideas")}
          </h3>
          <p className="text-sm text-slate-600">
            {t(
              "about.contactDescription",
              "You can send your suggestions, feedback or ideas for new features by email. Even a short message about what was useful (or missing) helps a lot."
            )}
          </p>
          <p className="text-sm font-mono text-slate-900">
            {t("about.emailLabel", "Email:")}
            <span className="ml-1">latwewesele@gmail.com</span>
          </p>
        </div>
        <p className="text-xs text-slate-400">
          {t(
            "about.footerNote",
            "Built as a small, independent project to help new marriages focus on what matters most: celebrating together, not spreadsheets."
          )}
        </p>
      </section>
    </div>
  );
};
